// Breakpoints
export const MOBILE_BREAKPOINT = 768;

// Minimum heights
export const DESKTOP_MIN_HEIGHT = 720;
export const MOBILE_MIN_HEIGHT = 550;

// Animation durations
export const ANIMATION_DURATION = '0.3s';
export const ANIMATION_EASING = 'ease-out';

// Z-index values
export const Z_INDEX_MODAL = 1000;
export const Z_INDEX_LOADER = 1000;

// Common spacing values
export const SPACING_XS = '4px';
export const SPACING_SM = '8px';
export const SPACING_MD = '16px';
export const SPACING_LG = '24px';
export const SPACING_XL = '32px';
export const SPACING_XXL = '40px';
export const SPACING_XXXL = '50px';
export const SPACING_XXXXL = '56px';

// IDTO API Configuration
export const IDTO_BASE_URL = 'https://prod.idto.ai';
export const IDTO_API_ENDPOINTS = {
  DIGILOCKER_INITIATE_SESSION: '/verify/digilocker/initiate_session',
  DIGILOCKER_GET_REFERENCE: '/verify/digilocker/get_reference',
} as const;

